import React, { useState, useCallback } from 'react';
import { message } from 'antd';
import RegenerateForm from './RegenerateForm';
import { safeParseJson, extractApiError } from './passwordValidation';

const RegeneratePage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');

  const handleSubmit = useCallback(async (values: { email: string }) => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${BUILD_VARS.QUERY_DOMAIN}/v1.0/auth/regenerate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });

      if (response.ok) {
        const data = await safeParseJson(response);
        setSuccess(
          data?.message ||
            'If an account with this email exists and needs activation, an email has been sent.',
        );
        message.success('Email sent successfully!');
      } else {
        const errorMessage = await extractApiError(
          response,
          'Failed to send activation email. Please try again.',
        );
        setError(errorMessage);
        message.error(errorMessage);
      }
    } catch (err) {
      const errorMessage = 'Network error. Please check your connection and try again.';
      setError(errorMessage);
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <RegenerateForm onSubmit={handleSubmit} loading={loading} error={error} success={success} />
  );
};

export default RegeneratePage;
